import { $translate } from '@/utils/i18n';
import formatTime from '@/utils/common.js';
// 通用状态
export const enableDisable = [
    {
        label: $translate('lang.E3202102260004', { defaultText: '启用' }),
        value: 'Y'
    }, {
        label: $translate('lang.E3202102260003', { defaultText: '停用' }),
        value: 'N'
    }
];

// 通用时间配置
export const pickerOptions = {
    shortcuts: [
        {
            text: $translate('lang.E3202101270017', { defaultText: '最近一周' }),
            onClick(picker) {
                picker.$emit('pick', [formatTime.initStartDate(6), formatTime.initEndDate()]);
            }
        },
        {
            text: $translate('lang.E3202101270019', { defaultText: '最近一个月' }),
            onClick(picker) {
                picker.$emit('pick', [formatTime.initStartDate(30), formatTime.initEndDate()]);
            }
        },
        {
            text: $translate('lang.E3202101270021', { defaultText: '最近三个月' }),
            onClick(picker) {
                picker.$emit('pick', [formatTime.initStartDate(90), formatTime.initEndDate()]);
            }
        }
    ]
};
/**
 * 脱敏数据
 * @param {String} val 需要脱敏字段数据
 * @param {Number} start 开始下标
 * @param {Number} end 结束下标
 * @returns
 */
export const replace = (val, start = 1, end = -1) => {
    let str;
    if (val && val.length > 0 && val.length < 4) {
        str = val.replaceAll(val.slice(start), '**');
    } else if (val.length >= 4) {
        str = val.replaceAll(val.slice(start, end), '****');
    } else {
        str = val;
    }
    return str;
};